import { Controller } from "@hotwired/stimulus";
import { CopyClipboard } from "flowbite";

export default class extends Controller {
  static targets = ["trigger", "target"];

  connect() {
    // Initialize the Flowbite CopyClipboard instance
    this.clipboard = new CopyClipboard(this.triggerTarget, this.targetTarget, {
      contentType: "input",
      htmlEntities: false,
      onCopy: () => {
        // Optionally update the UI after a successful copy
        this.showSuccess();
      },
    });
  }

  // Called when the button is clicked
  copy() {
    this.clipboard.copy();
  }

  showSuccess() {
    // Example: Swap messages (you can adjust this as needed)
    const defaultMessage = this.element.querySelector("#default-message");
    const successMessage = this.element.querySelector("#success-message");
    defaultMessage.classList.add("hidden");
    successMessage.classList.remove("hidden");

    // Revert back after 2 seconds
    setTimeout(() => {
      defaultMessage.classList.remove("hidden");
      successMessage.classList.add("hidden");
    }, 2000);
  }
}
